module.exports = __webpack_public_path__ + "static/media/chat-bubble-icon.db2a36cd.svg";